import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ name }) => {
  // icons optimized with https://jakearchibald.github.io/svgomg/
  // use button__icon--fillBased and button__icon--strokeBased classes instead of inline attributes

  switch (name) {
    
    case "icon-shower-location-a01-shower": {
      return (
        <svg className="button__icon" width="29" height="26" viewBox="0 0 29 26" xmlns="http://www.w3.org/2000/svg">
          <title>icon-shower-location-a01-shower</title>
          <g className="button__icon--strokeBased">
            <path d="M13.438 18c0-1.105.893-2 1.998-2s2.002.895 2.002 2c0 1.104-.897 2-2.002 2-1.105 0-1.998-.896-1.998-2M5.438 18c0-1.105.893-2 1.998-2s2.002.895 2.002 2c0 1.104-.897 2-2.002 2-1.105 0-1.998-.896-1.998-2M6.438 12c0-1.104.893-2 1.998-2s2.002.896 2.002 2-.897 2-2.002 2c-1.105 0-1.998-.896-1.998-2M4.438 24c0-1.105.896-2 1.998-2 1.105 0 2.002.895 2.002 2s-.897 2-2.002 2c-1.102 0-1.998-.895-1.998-2M21.438 18c0-1.105.896-2 2-2 1.105 0 2 .895 2 2 0 1.104-.895 2-2 2-1.104 0-2-.896-2-2M20.438 12c0-1.104.895-2 2-2 1.104 0 2 .896 2 2s-.896 2-2 2c-1.105 0-2-.896-2-2M22.438 24c0-1.105.896-2 2-2 1.103 0 2 .895 2 2s-.897 2-2 2c-1.104 0-2-.895-2-2M13.438 24c0-1.105.893-2 1.998-2s2.002.895 2.002 2-.897 2-2.002 2c-1.105 0-1.998-.895-1.998-2M13.438 12c0-1.104.893-2 1.998-2s2.002.896 2.002 2-.897 2-2.002 2c-1.105 0-1.998-.896-1.998-2" fill="#3784C0"/>
          </g>
          <g className="button__icon--fillBased">
            <path d="M26.584 4.678c.835-.014 1.668-.73 1.668-1.61 0-.843-.734-1.424-1.614-1.57-.46-.043-.657-.067-.887-.08-1.21-.07-2.42-.128-3.632-.17-2.42-.083-4.84-.116-7.265-.116-2.42 0-4.843.033-7.265.117-1.142.04-2.284.09-3.424.155-.388.023-.865.038-1.164.07-.955.07-1.562.748-1.562 1.593 0 .854.72 1.58 1.608 1.632.375.017.69-.004.9 0l3.634.064c2.424.036 4.847.055 7.27.055 2.423 0 4.845-.02 7.266-.056L25.75 4.7l.834-.022z" stroke="#3784C0"/>
          </g>
        </svg>
      );
    }
    
    case "icon-shower-location-a02-bath": {
      return (
        <svg className="button__icon button__icon--fillBased" width="36" height="27" viewBox="0 0 36 27" xmlns="http://www.w3.org/2000/svg">
          <title>icon-shower-location-a02-bath</title>
          <g>
            <path d="M30.876 11.126c1.923-.012 3.095.074 2.826 2.237-.657 2.71-2.217 7.094-5.68 7.28l.354.52 1.558 2.482c.545.868.27 1.992-.363 2.31-1.012.504-2.048-.19-2.6-1.057l-2.686-4.215-7.113.006-6.974-.007-2.687 4.215c-.547.87-1.587 1.56-2.6 1.056-.634-.317-.91-1.44-.363-2.31l1.558-2.482.354-.518c-3.465-.187-5.023-4.572-5.682-7.28-.268-2.164.904-2.24 2.828-2.238l13.542.005 13.728-.004zM30.74 1.125c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4"/>
          </g>
        </svg>
      );
    }

    case "icon-shower-installation-type-a01-exposed": {
      return (
        <svg className="button__icon button__icon--strokeBased" width="27" height="38" viewBox="0 0 27 38" xmlns="http://www.w3.org/2000/svg">
          <title>icon-shower-installation-type-a01-exposed</title>
          <g>
            <path d="M.998 11.922v21.634l6.895 3.442 18.577-9.506-.19-21.307-6.704-2.622z"/>
            <path d="M7.893 36.834v-21.47l18.386-9.18"/>
            <path d="M.998 11.922v21.634l6.895 3.442 18.577-9.506-.19-21.307-6.704-2.622zM7.893 15.363l-6.895-3.44"/>
            <path d="M16.333 23.81s1.468-1.85 3.1-1.633c-.086-.116-.19-.225-.31-.325-2.012-1.657-4.217 1.126-4.217 1.126-1.682 2.302-2.045 5.272-.18 5.917.17.06.342.083.513.093-.72-1.19-.217-3.384 1.093-5.178z"/>
            <path d="M14.802 28.84c.202.338.496.6.904.74 1.845.646 3.71-1.958 3.71-1.958s2.53-3.518.64-5.094c-.364-.304-.737-.457-1.102-.506l.015.02M8.278 8.265v-6.92C8.625.85 9.318.6 10.358.6s1.733.248 2.08.742v5.26"/>
          </g>
        </svg>
      );
    }
    
    case "icon-shower-installation-type-a02-exposed-with-concealed": {
      return (
        <svg className="button__icon button__icon--strokeBased" width="28" height="36" viewBox="0 0 28 36" xmlns="http://www.w3.org/2000/svg">
          <title>icon-shower-installation-type-a02-exposed-with-concealed</title>
          <g>
            <path d="M1.09 9.5v22L7.987 35l18.577-9.667-.19-21.666L19.668 1z"/>
            <path d="M7.986 34.833V13l18.386-9.333"/>
            <path d="M1.09 9.5v22L7.987 35l18.577-9.667-.19-21.666L19.668 1zM7.986 13L1.09 9.5"/>
            <path d="M17.313 20.527s1.468-1.883 3.1-1.66c-.087-.12-.19-.23-.312-.332-2.01-1.685-4.215 1.146-4.215 1.146-1.68 2.34-2.045 5.362-.18 6.017.17.06.342.085.513.095-.72-1.21-.216-3.44 1.095-5.265z"/>
            <path d="M15.78 25.642c.203.344.497.61.905.754 1.845.656 3.71-1.993 3.71-1.993s2.532-3.577.642-5.18c-.366-.31-.738-.464-1.103-.515l.015.02"/>
          </g>
        </svg>
      );
    }

    case "icon-shower-installation-type-a03-concealed": {
      return (
        <svg className="button__icon button__icon--strokeBased" width="21" height="34" viewBox="0 0 21 34" xmlns="http://www.w3.org/2000/svg">
          <title>icon-shower-installation-type-a03-concealed</title>
          <g>
            <path d="M.72 10.537v22.087l18.854-9.872L19.38 1z"/>
            <path d="M9.95 18.47s1.49-1.89 3.148-1.667c-.09-.118-.193-.23-.318-.332-2.04-1.69-4.28 1.15-4.28 1.15-1.705 2.35-2.074 5.383-.182 6.04.174.062.348.086.52.096-.73-1.214-.218-3.455 1.112-5.286z"/>
            <path d="M8.396 23.605c.205.345.503.612.917.757 1.873.658 3.766-2 3.766-2s2.568-3.592.65-5.2c-.37-.31-.75-.467-1.12-.518l.015.02"/>
          </g>
        </svg>
      );
    }

    case "icon-shower-shape-a01-square": {
      return (
        <svg className="button__icon button__icon--strokeBased" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <title>icon-shower-shape-a01-square</title>
          <g transform="translate(.5)">
            <circle cx="14.5" cy="22.5" r="4.5"/>
            <path d="M.5.5h28v29H.5z"/>
          </g>
        </svg>
      );
    }

    case "icon-shower-shape-a02-round": {
      return (
        <svg className="button__icon button__icon--strokeBased" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <title>icon-shower-shape-a02-round</title>
        <g transform="translate(1 1)">
          <path d="M15 27c2.485 0 4.5-2.015 4.5-4.5S17.485 18 15 18s-4.5 2.015-4.5 4.5S12.515 27 15 27z"/>
          <circle cx="15" cy="15" r="15"/>
        </g>
      </svg>
      );
    }

    case "icon-shower-functionality-a01-square": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
          <title>icon-shower-functionality-a01-square</title>
          <g >
            <circle cx="15" cy="22.5" r="4.5" />
            <circle cx="6.923" cy="11.053" r="3" />
            <circle cx="15.035" cy="11.053" r="3" />
            <circle cx="23.094" cy="11.053" r="3" />
          </g>
          <g >  
            <path d="M1 .5h28v29H1z" />
          </g>
        </svg>
      );
    }

    case "icon-shower-functionality-a01-round": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" >
          <title>icon-shower-functionality-a01-round</title>
          <g transform="translate(1 1)">
            <circle cx="15" cy="22.5" r="4.5" />
            <circle cx="15" cy="15" r="15" />
            <circle cx="6.923" cy="11.053" r="3" />
            <circle cx="15.035" cy="11.053" r="3" />
            <circle cx="23.094" cy="11.053" r="3" />
          </g>
        </svg>
      );
    }

    case "icon-shower-functionality-a02-square": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
          <title>icon-shower-functionality-a02-square</title>
          <g transform="translate(0 -.555)">
            <circle cx="15" cy="23.469" r="4.5" />
            <circle cx="9.5" cy="12" r="3" />
            <circle cx="20.5" cy="12" r="3" />
          </g>
          <g>  
            <path d="M1 1.055h28v29H1z" />
          </g>
        </svg>
      );
    }

    case "icon-shower-functionality-a02-round": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
          <title>icon-shower-functionality-a02-round</title>
          <g transform="translate(1 1.445)">
            <circle cx="15" cy="22.469" r="4.5" />
            <circle cx="15" cy="15" r="15" />
            <circle cx="9.5" cy="11" r="3" />
            <circle cx="20.5" cy="11" r="3" />
          </g>
        </svg>
      );
    }

    case "icon-shower-functionality-a03-square": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
          <title>icon-shower-functionality-a03-square</title>
          <g>
            <path d="M15 27c2.485 0 4.5-2.015 4.5-4.5S17.485 18 15 18s-4.5 2.015-4.5 4.5S12.515 27 15 27z" />
          </g>
          <g>  
            <circle cx="15" cy="12" r="3" />
          </g>
          <g>  
            <path d="M1 .5h28v29H1z" />
          </g>
        </svg>
      );
    }

    case "icon-shower-with-holder-a01-square": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
          <title>icon-shower-with-holder-a01-square</title>
          <g transform="translate(0 -.555)">
            <circle cx="15" cy="23.469" r="4.5" />
            <circle cx="9.5" cy="12" r="3" />
            <circle cx="20.5" cy="12" r="3" />
            <path d="M1 1.055h28v29H1z" />
          </g>
        </svg>
      );
    }

    case "icon-shower-with-holder-a01-round": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
          <title>icon-shower-with-holder-a01-round</title>
          <g transform="translate(1 1.445)" >
            <circle cx="15" cy="22.469" r="4.5" />
            <circle cx="15" cy="15" r="15" />
            <circle cx="9.5" cy="11" r="3" />
            <circle cx="20.5" cy="11" r="3" />
          </g>
        </svg>
      );
    }

    case "icon-shower-with-holder-a02-square": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="35" height="31" viewBox="0 0 35 31">
          <title>icon-shower-with-holder-a02-square</title>
          <g transform="translate(-.5)">
            <circle cx="15" cy="23.469" r="4.5" />
            <circle cx="9.5" cy="12" r="3" />
            <circle cx="20.5" cy="12" r="3" />
          </g>
          <g>  
            <path d="M1 1.055h28v29H1z" />
          </g>
          <g>  
            <rect x="30.5" y="15.5" width="4" height="11" rx="2" />
          </g>
        </svg>
      );
    }

    case "icon-shower-with-holder-a02-round": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="37" height="32" viewBox="0 0 37 32">
          <title>icon-shower-with-holder-a02-round</title>
          <g transform="translate(.72 .675)">
            <circle cx="15" cy="22.469" r="4.5" />
            <circle cx="15" cy="15" r="15" />
            <circle cx="9.5" cy="11" r="3" />
            <circle cx="20.5" cy="11" r="3" />
          </g>
          <g>  
            <rect x="31.281" y="15.5" width="4" height="11" rx="2" />
          </g>
        </svg>
      );
    }

    case "icon-shower-rail-holder-a01-railset": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="34" height="28" viewBox="0 0 34 28">
          <title>icon-shower-rail-holder-a01-railset</title>
          <g>
            <path d="M31.58 13.893c.33.586 1.075.792 1.66.46.586-.33.793-1.074.46-1.66-.33-.586-1.072-.792-1.66-.46-.585.33-.79 1.074-.46 1.66M29.508 11.383c.35.62 1.138.84 1.76.488.62-.35.838-1.137.487-1.758-.35-.62-1.14-.84-1.76-.488-.62.35-.84 1.14-.487 1.76M28.684 9.29c.62-.352.84-1.14.49-1.76-.352-.62-1.14-.84-1.76-.49-.62.352-.84 1.14-.49 1.76.352.62 1.14.84 1.76.49M26.925 17.193c.35.622 1.138.84 1.76.49.62-.352.838-1.14.488-1.76-.35-.62-1.14-.84-1.76-.488-.62.35-.84 1.14-.488 1.758M24.988 13.966c.35.62 1.138.84 1.76.49.62-.353.838-1.14.487-1.762-.35-.62-1.138-.84-1.76-.487-.62.35-.838 1.138-.487 1.76M23.05 10.738c.35.62 1.138.84 1.76.488.62-.35.84-1.14.488-1.76-.35-.62-1.138-.838-1.76-.488-.62.35-.838 1.14-.487 1.76M21.76 19.776c.35.62 1.138.84 1.76.49.62-.352.838-1.14.488-1.76-.35-.62-1.14-.84-1.76-.49-.62.35-.84 1.14-.488 1.76M20.47 16.548c.35.62 1.137.84 1.758.49.62-.352.84-1.14.488-1.76-.35-.62-1.14-.84-1.76-.49-.62.352-.84 1.14-.487 1.76M19.823 13.32c.35.62 1.138.84 1.76.488.62-.35.838-1.138.487-1.76-.35-.62-1.138-.838-1.76-.487-.62.35-.838 1.14-.487 1.76"/>
            <path d="M6.122 25.696s-1.06-.452-.252-2.136c.81-1.685 7.217-15.236 20.734-20.1 0 0 2.017-1.045 2.07.645 0 0-.062.786-.237 1.265-.175.48-.166.41-1.473.93-1.308.523-12.084 4.687-17.583 19.247 0 0-.526 2.16-1.974.998l-1.284-.85z"/>
            <path d="M3.62 17.243h5.74L11 15H3.62V1H1.38v26H3.62v-9.757z" />
          </g>
        </svg>
      );
    }

    case "icon-shower-rail-holder-a02-holderset": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="32" height="26" viewBox="0 0 32 26">
          <title>icon-shower-rail-holder-a02-holderset</title>
          <g >
            <path fill="#3784C0"  d="M29.22 11.893c.33.586 1.075.792 1.66.46.587-.33.793-1.074.462-1.66-.33-.586-1.074-.792-1.66-.46-.587.33-.793 1.074-.462 1.66M27.148 9.383c.35.62 1.138.84 1.76.488.62-.35.838-1.137.487-1.758-.35-.62-1.138-.84-1.76-.488-.62.35-.838 1.14-.487 1.76M26.324 7.29c.62-.352.84-1.14.49-1.76-.352-.62-1.14-.84-1.76-.49-.62.352-.84 1.14-.49 1.76.352.62 1.14.84 1.76.49M24.565 15.193c.35.622 1.138.84 1.76.49.62-.352.838-1.14.488-1.76-.35-.62-1.138-.84-1.76-.488-.62.35-.84 1.14-.488 1.758M22.628 11.966c.35.62 1.14.84 1.76.49.62-.353.84-1.14.488-1.762-.35-.62-1.14-.84-1.76-.487-.62.35-.84 1.138-.488 1.76M20.692 8.738c.35.62 1.137.84 1.76.488.62-.35.838-1.14.487-1.76-.35-.62-1.14-.838-1.76-.488-.62.35-.84 1.14-.488 1.76M19.4 17.776c.35.62 1.138.84 1.76.49.62-.352.838-1.14.488-1.76-.35-.62-1.14-.84-1.76-.49-.62.35-.84 1.14-.488 1.76M18.11 14.548c.35.62 1.137.84 1.758.49.62-.352.84-1.14.488-1.76-.35-.62-1.138-.84-1.76-.49-.62.352-.838 1.14-.487 1.76M17.463 11.32c.35.62 1.14.84 1.76.488.62-.35.84-1.138.488-1.76-.35-.62-1.138-.838-1.76-.487-.62.35-.838 1.14-.487 1.76"/>
            <path d="M3.762 23.696s-1.06-.452-.25-2.136c.808-1.685 7.216-15.236 20.732-20.1 0 0 2.018-1.045 2.07.645 0 0-.06.786-.237 1.265-.175.48-.165.41-1.472.93-1.31.523-12.084 4.687-17.583 19.247 0 0-.527 2.16-1.976.998l-1.284-.85z"/>
            <path d="M7 15.243H.72V13H9" />
          </g>
        </svg>
      );
    }

    case "icon-shower-head-mounted-a01-wallmounted": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24">
          <title>icon-shower-head-mounted-a01-wallmounted</title>
          <g>
            <path d="M15.833 16.257c0-.99.806-1.794 1.804-1.794.997 0 1.806.803 1.806 1.794 0 .99-.81 1.796-1.806 1.796-.998 0-1.804-.805-1.804-1.796M8.61 16.257c0-.99.808-1.794 1.805-1.794.998 0 1.807.803 1.807 1.794 0 .99-.81 1.796-1.807 1.796-.997 0-1.804-.805-1.804-1.796M9.514 10.873c0-.99.807-1.795 1.804-1.795s1.806.804 1.806 1.795c0 .99-.81 1.795-1.806 1.795-.997 0-1.804-.805-1.804-1.795M7.708 21.745c0-.992.81-1.795 1.805-1.795.997 0 1.806.803 1.806 1.795 0 .992-.81 1.795-1.807 1.795-.996 0-1.805-.803-1.805-1.795M23.054 16.257c0-.99.81-1.794 1.807-1.794.998 0 1.805.803 1.805 1.794 0 .99-.807 1.796-1.804 1.796s-1.806-.805-1.806-1.796M22.15 10.873c0-.99.81-1.795 1.807-1.795.997 0 1.805.804 1.805 1.795 0 .99-.808 1.795-1.805 1.795-.997 0-1.806-.805-1.806-1.795M24.054 21.745c0-.992.81-1.795 1.807-1.795.996 0 1.805.803 1.805 1.795 0 .992-.81 1.795-1.804 1.795-.997 0-1.806-.803-1.806-1.795M15.833 21.745c0-.992.806-1.795 1.804-1.795.997 0 1.806.803 1.806 1.795 0 .992-.81 1.795-1.806 1.795-.998 0-1.804-.803-1.804-1.795M15.833 10.873c0-.99.806-1.795 1.804-1.795.997 0 1.806.804 1.806 1.795 0 .99-.81 1.795-1.806 1.795-.998 0-1.804-.805-1.804-1.795"/>
            <path d="M28.7 4.3c.754-.012 1.506-.654 1.506-1.445 0-.755-.663-1.277-1.458-1.41-.414-.036-.593-.058-.8-.07-1.093-.063-2.184-.115-3.28-.152-2.185-.075-4.37-.105-6.557-.105-2.185 0-4.37.03-6.558.105-1.03.036-2.062.082-3.09.14-.35.02-.782.035-1.05.064C6.547 1.49 6 2.097 6 2.857c0 .766.65 1.417 1.452 1.464.34.016.622-.003.814 0l3.28.058c2.187.032 4.375.05 6.563.05 2.185 0 4.37-.018 6.557-.05l3.28-.058.753-.02z"/>
            <path d="M6.708 3.894H1.23V1.65h5.478" />
          </g>
        </svg>
      );
    }

    case "icon-shower-head-mounted-a02-ceilingmounted": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="26" height="28" viewBox="0 0 26 28">
          <title>icon-shower-head-mounted-a02-ceilingmounted</title>
          <g>
            <path d="M10.833 20.257c0-.99.806-1.794 1.804-1.794.997 0 1.806.803 1.806 1.794 0 .99-.81 1.796-1.806 1.796-.998 0-1.804-.805-1.804-1.796M3.61 20.257c0-.99.808-1.794 1.805-1.794.998 0 1.807.803 1.807 1.794 0 .99-.81 1.796-1.807 1.796-.997 0-1.804-.805-1.804-1.796M4.514 14.873c0-.99.807-1.795 1.804-1.795s1.806.804 1.806 1.795c0 .99-.81 1.795-1.806 1.795-.997 0-1.804-.805-1.804-1.795M2.708 25.745c0-.992.81-1.795 1.805-1.795.997 0 1.806.803 1.806 1.795 0 .992-.81 1.795-1.807 1.795-.996 0-1.805-.803-1.805-1.795M18.054 20.257c0-.99.81-1.794 1.807-1.794.998 0 1.805.803 1.805 1.794 0 .99-.807 1.796-1.804 1.796s-1.806-.805-1.806-1.796M17.15 14.873c0-.99.81-1.795 1.807-1.795.997 0 1.805.804 1.805 1.795 0 .99-.808 1.795-1.805 1.795-.997 0-1.806-.805-1.806-1.795M19.054 25.745c0-.992.81-1.795 1.807-1.795.996 0 1.805.803 1.805 1.795 0 .992-.81 1.795-1.804 1.795-.997 0-1.806-.803-1.806-1.795M10.833 25.745c0-.992.806-1.795 1.804-1.795.997 0 1.806.803 1.806 1.795 0 .992-.81 1.795-1.806 1.795-.998 0-1.804-.803-1.804-1.795M10.833 14.873c0-.99.806-1.795 1.804-1.795.997 0 1.806.804 1.806 1.795 0 .99-.81 1.795-1.806 1.795-.998 0-1.804-.805-1.804-1.795"/>
            <path d="M23.7 8.3c.754-.012 1.506-.654 1.506-1.445 0-.755-.663-1.277-1.458-1.41-.414-.036-.593-.058-.8-.07-1.093-.063-2.184-.115-3.28-.152-2.185-.075-4.37-.105-6.557-.105-2.185 0-4.37.03-6.558.105-1.03.036-2.062.082-3.09.14-.35.02-.782.035-1.05.064C1.547 5.49 1 6.097 1 6.857c0 .766.65 1.417 1.452 1.464.34.016.622-.003.814 0l3.28.058c2.187.032 4.375.05 6.563.05 2.185 0 4.37-.018 6.557-.05l3.28-.058.753-.02zM11 5.04V.54h4v4.5"/>
            <path d="M11 5.04V.54h4v4.5" />
          </g>
        </svg>
      );
    }

    case "icon-answer-boiling": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="19" height="35" viewBox="0 0 19 35" aria-labelledby="title">
          <title id="title">icon-answer-boiling</title>
          <g>
            <path d="M1 11.826l2.126 18.628C3.356 32.474 5.066 34 7.1 34h4.8c2.032 0 3.742-1.526 3.973-3.546L18 11.826"/>
            <path d="M3.217 15.94c1.893-1.286 3.785-1.5 5.677-.643 2.838 1.285 4.73 1.285 6.15 0M7.652 0c1.15 1.314 1.396 3.12.74 5.42-.658 2.3-.41 3.942.738 4.928M10.61.74c1.148 1.313 1.395 3.12.738 5.42s-.41 3.94.74 4.927"/>
          </g>
        </svg>
      );
    }
    case "icon-answer-chill-and-spark": {
      return (
        <svg className="button__icon" xmlns="http://www.w3.org/2000/svg" width="21" height="37" viewBox="0 0 21 37" aria-labelledby="title">
          <title id="title">icon-answer-chill-and-spark</title>
          <g className="button__icon--strokeBased">
            <path d="M1 12l2.37 20.46C3.602 34.478 5.31 36 7.342 36h5.98c2.03 0 3.74-1.522 3.974-3.54L19.667 12"/>
            <path d="M3.667 15.733c2.133-1.066 4.266-1.244 6.4-.533 3.2 1.067 5.333 1.067 6.933 0"/>
          </g>
          <g className="button__icon--fillBased" transform="translate(5.267 17.933)">
            <circle cx="6.767" cy="12.567" r="2.5"/>
            <circle cx="2" cy="8.867" r="2"/>
            <circle cx="6.3" cy="6.767" r="1.5"/>
            <circle cx="6.867" cy="3.067" r="1"/>
            <circle cx="3.667" cy="1" r="1"/>
            <circle cx="2.067" cy="13.2" r="1"/>
          </g>
          <g className="button__icon--strokeBased">
            <path d="M10.582 1v12M8.613 2.548l1.887 1.55 1.887-1.55M8.613 11.84l1.887-1.55 1.887 1.55"/>
            <path d="M15.737 4.08l-10.392 6M13.412 3.15l-.398 2.408 2.285.86M5.366 7.795l2.284.86-.397 2.41"/>
            <path d="M15.655 10.08l-10.392-6M15.3 7.6l-2.286.862.398 2.408M7.253 2.956l.397 2.41-2.284.86"/>
          </g>
        </svg>
      );
    }
    case "icon-answer-chill-and-spark-and-boiling": {
      return (
        <svg className="button__icon" xmlns="http://www.w3.org/2000/svg" width="21" height="37" viewBox="0 0 21 37" aria-labelledby="title">
          <title id="title">icon-answer-chill-and-spark-and-boiling</title>
          <g className="button__icon--strokeBased">
            <path d="M1 12l2.37 20.46C3.602 34.478 5.31 36 7.342 36h5.98c2.03 0 3.74-1.522 3.974-3.54L19.667 12"/>
            <path d="M3.667 15.733c2.133-1.066 4.266-1.244 6.4-.533 3.2 1.067 5.333 1.067 6.933 0"/>
          </g>
          <g className="button__icon--fillBased" transform="translate(5.267 17.933)">
            <circle cx="6.767" cy="12.567" r="2.5"/>
            <circle cx="2" cy="8.867" r="2"/>
            <circle cx="6.3" cy="6.767" r="1.5"/>
            <circle cx="6.867" cy="3.067" r="1"/>
            <circle cx="3.667" cy="1" r="1"/>
            <circle cx="2.067" cy="13.2" r="1"/>
          </g>
        </svg>
      );
    }

    case "icon-answer-new-required": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-labelledby="title">
          <title id="title">icon-answer-new-required</title>
          <path d="M16 31C7.73 31 1 24.27 1 16S7.73 1 16 1s15 6.73 15 15-6.73 15-15 15zM15.49 7.04v17.926M7.036 16H24.96" />
        </svg>
      );
    }
    case "icon-answer-existing": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="31" height="29" viewBox="0 0 31 29" aria-labelledby="title">
          <title id="title">icon-answer-existing</title>
          <g>
            <path d="M28.188 11.057c-1.6-5.61-6.716-9.71-12.715-9.71-5.998 0-11.053 4.1-12.652 9.71" />
            <path d="M30.01 6.258l-1.822 4.8-4.526-1.8M2.86 18.617c1.6 5.61 6.717 9.71 12.716 9.71 5.998 0 11.052-4.1 12.65-9.71" />
            <path d="M1.04 23.416l1.82-4.8 4.527 1.8" />
          </g>
        </svg>
      );
    }
    case "icon-result-button-location": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 12 17" aria-labelledby="title">
          <title id="title">icon-result-button-location</title>
          <path d="M6.143 17C2.713 11.655 1 8.036 1 6.143 1 3.303 3.303 1 6.143 1s5.143 2.303 5.143 5.143c0 1.893-1.715 5.512-5.143 10.857zm0-8C7.72 9 9 7.72 9 6.143c0-1.578-1.28-2.857-2.857-2.857-1.578 0-2.857 1.28-2.857 2.857C3.286 7.72 4.566 9 6.143 9z" />
        </svg>
      );
    }
    case "icon-result-button-online-shop": {
      return (
        <svg className="button__icon button__icon--strokeBased" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" aria-labelledby="title">
          <title id="title">icon-result-button-online-shop</title>
          <g>
            <path d="M12.153 15.182c0-.804.66-1.455 1.474-1.455s1.473.65 1.473 1.455c0 .803-.66 1.454-1.473 1.454-.814 0-1.474-.65-1.474-1.454zM4.788 15.182c0-.804.66-1.455 1.473-1.455.815 0 1.474.65 1.474 1.455 0 .803-.66 1.454-1.473 1.454-.813 0-1.472-.65-1.472-1.454zM.368 1.364h2.21l1.855 9.155c.206 1.02 1.113 1.753 2.166 1.753h8.5" />
            <path d="M3.315 3.545h13.258l-.575 4.544c-.092.727-.72 1.274-1.462 1.274H4.42" />
          </g>
        </svg>
      );
    }
    default: {
      return (
        <svg height="20" width="100">
          <text x="0" y="15" fill="red">No icon</text>
        </svg>
      );
    }
  }
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;


// WEBPACK FOOTER //
// ./src/components/Icon.js